import loadable, { LoadingWithProgress } from './loadable'
import { uuid } from './uuid';
import { getParams } from './getParams';

const RH_TASK_STATUS = {
  'QUEUED': '排队中',
  'RUNNING': '进行中',
  'FAILED': '任务失败',
  'SUCCESS': '任务成功',
}

const STATUS_COLOR = {
  'QUEUED': 'magenta',
  'RUNNING': 'gold',
  'FAILED': 'red',
  'SUCCESS': 'green',
}

const utils = {
  loadable,
  LoadingWithProgress,
  uuid,
  getParams,
  RH_TASK_STATUS,
  STATUS_COLOR
};
export default utils;